const STORAGE_KEY_PREFIX = "agent_daily_cost_";

function todayKey(): string {
  return `${STORAGE_KEY_PREFIX}${new Date().toISOString().slice(0, 10)}`;
}

export function loadDailyCost(): number {
  try {
    const raw = localStorage.getItem(todayKey());
    return raw ? Number(raw) : 0;
  } catch {
    return 0;
  }
}

export function saveDailyCost(value: number): void {
  try {
    localStorage.setItem(todayKey(), String(value));
  } catch {
    // storage unavailable — silent
  }
}

export const DAILY_CAP_USD = 0.5;
